/**
 * El cliente · `BFF_BO.md` §3.2
 *
 * Eden, no `fetch` a mano y no un cliente generado del OpenAPI. Los dos añaden un
 * artefacto que hay que mantener sincronizado, y el segundo además pierde
 * precisión. Con Eden **el front consume la API con los tipos del servidor**: si
 * cambia la respuesta de un endpoint, la pantalla que la usa deja de compilar.
 */
import { treaty } from '@elysiajs/eden';
import type { App } from '@kiap/api';
import { fetchConSesion, type OpcionesDeSesion } from '@/shared/api/sesion';

/**
 * La base, sin barra final y **sin** `/v1`: la versión la pone Eden al recorrer
 * `api.v1.me`, y duplicarla da `/v1/v1/me`.
 */
export const BASE =
  (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/+$/, '') ??
  'http://localhost:3000';

const opciones: OpcionesDeSesion = { base: BASE };

/**
 * El `fetch` que usa Eden lleva puesto el bucle de refresco, así que **ninguna
 * pantalla se entera** de que la sesión se renueva. Es el punto entero de tener
 * una sola implementación.
 */
export const api = treaty<App>(BASE, {
  /*
   * El único `as` de la frontera, y aquí está el por qué: Eden pide `typeof
   * fetch`, y los tipos de Bun le cuelgan a `fetch` un `preconnect` que ninguna
   * función nuestra tiene. Es una propiedad que Eden no llama —solo pasa la
   * función—, así que la afirmación no oculta nada. Alternativa era ensanchar
   * `Peticion` con un `preconnect` falso, que sería mentir en el tipo en vez de
   * en una línea comentada.
   */
  fetcher: fetchConSesion(opciones) as unknown as typeof fetch,
});

export const opcionesDeSesion = opciones;
